<a class="navbar-brand" *ngIf="!AppService.isMobile()"  [routerLink]="['/publish/']">
    <button class="publish-search-btn"   >{{'sale4you.label.button.publish' | translate}}<span class="iconify publish-search-icon" data-icon="ant-design:plus-outlined"></span></button>
</a>